import { render, staticRenderFns } from "./publish.vue?vue&type=template&id=319fa0aa&scoped=true"
import script from "./publish.vue?vue&type=script&lang=js"
export * from "./publish.vue?vue&type=script&lang=js"
import style0 from "./publish.vue?vue&type=style&index=0&id=319fa0aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319fa0aa",
  null
  
)

export default component.exports